import { COLOURS } from './colours';
export const MARGIN_TARGETS = [0.55, 0.65, 0.75];
export const MARGIN_SEGMENTS = ['CBI', 'Advisory', 'ICP'];
export function getMargin(partnerPrice, clientPrice) {
  if (clientPrice === 0) {
    return 0;
  }
  const profit = getProfit(partnerPrice, clientPrice);
  const margin = profit / clientPrice;
  return margin;
}
export function getProfit(partnerPrice, clientPrice) {
  return clientPrice - partnerPrice;
}
export function getMarginTagColor(margin) {
  if (margin < MARGIN_TARGETS[0]) {
    return COLOURS.red;
  }
  if (margin < MARGIN_TARGETS[1]) {
    return COLOURS.orange;
  }
  if (margin < MARGIN_TARGETS[2]) {
    return COLOURS.lightOrange;
  }
  return COLOURS.green;
}
export function getDesiredCost(clientPrice, margin = MARGIN_TARGETS[2]) {
  return clientPrice - clientPrice * margin;
}